import React from 'react'
import block from 'bem-cn'

import { BottomHeader } from './BottomHeader/BottomHeader'
import { TopHeader } from './TopHeader/TopHeader'

import './HeaderDesktop.scss'

const b = block('header-block-desktop')

export const HeaderDesktop: React.FC = () => (
  <header className={b()}>
    <TopHeader />
  </header>
)
